import React from 'react';
import { Link } from 'react-router-dom';
import './Banner.scss';
import IndexingBanner from '../../../indexing/IndexManagement/IndexingBanner';

const IndexingBannerComponent: React.FC = () => {
  return (
    <>
      <div style={{ marginBottom: '64px' }}>
        <h1>Indexing Banner</h1>
        <div>
          Indexing Banner display messages for indexing based on type of index which is currently in flight.
          if there are multiple indexes are in progress it show different message Multiple indices are currently in flight.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{ marginBottom: '32px' ,marginLeft:"120px"}}>

          <IndexingBanner message={'Standard Index is currently in flight'} />
        </div>
        <div style={{ marginBottom: '32px' ,marginLeft:"120px" }}>
          <IndexingBanner message={'Multiple indices are currently in flight'} />
        </div>
      </div>
    </>
  );
};

export default IndexingBannerComponent;
